import { gsap } from "gsap/dist/gsap";

class TabComponent extends HTMLElement {
  constructor() {
    super();

    this.tabs = [];
    this.firstTab = null;
    this.lastTab = null;

    this.tabs = [...this.querySelectorAll("[role=tab]")];
    this.tabpanels = new Map();

    this.animate = "animate" in this.dataset;

    if (window.matchMedia("(prefers-reduced-motion)").matches) {
      this.animate = false;
    }

    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      const tabpanel = document.getElementById(
        tab.getAttribute("aria-controls")
      );
      tab.tabIndex = -1;
      tab.setAttribute("aria-selected", "false");
      this.tabpanels.set(tab, tabpanel);

      tab.addEventListener("keydown", this.onKeydown.bind(this));
      tab.addEventListener("click", this.onClick.bind(this));
      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    });

    this.currentTab = null;
    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(newTab, setFocus) {
    if (typeof setFocus !== "boolean") {
      setFocus = true;
    }

    if (this.animate && this.currentTab) {
      if (newTab === this.currentTab || this.t) return;
      const currentTab = this.currentTab;
      const currentTabPanel = this.tabpanels.get(currentTab);
      const newTabPanel = this.tabpanels.get(newTab);

      currentTabPanel.parentElement.style.position = "relative";

      this.t = gsap.timeline({
        onComplete: () => {
          this.t = null;
        },
      });
      this.t.to(newTabPanel, {
        display: "block",
        position: "absolute",
        overflow: "hidden",
        opacity: 0,
        duration: 0,
        onComplete: () => {
          currentTabPanel.style.position = "absolute";
          currentTabPanel.style.top = 0;
          currentTabPanel.style.width = "100%";
          newTabPanel.style.position = null;
          newTabPanel.style.top = null;
        },
      });

      this.t.addLabel("p1");

      // Animate height
      this.t.fromTo(
        newTabPanel,
        {
          height: currentTabPanel.scrollHeight,
        },
        {
          height: newTabPanel.scrollHeight,
          duration: 0.4,
          ease: "ease-in-out",
          onComplete: () => {
            newTab.setAttribute("aria-selected", "true");
            newTab.removeAttribute("tabindex");
            newTabPanel.classList.add("tab--active");
            if (setFocus) {
              newTab.focus();
            }
            newTabPanel.style.display = null;
            newTabPanel.style.overflow = null;
            newTabPanel.style.height = null;
            newTabPanel.style.opacity = null;
            currentTabPanel.parentElement.style.position = null;
          },
        }
      );

      // Animate opacity for new panel
      this.t.to(newTabPanel, { opacity: 1, duration: 0.25 }, "p1+=0.15");

      // Animate opacity for old panel
      this.t.fromTo(
        currentTabPanel,
        {
          opacity: 1,
        },
        {
          opacity: 0,
          duration: 0.25,
          onComplete: () => {
            currentTab.setAttribute("aria-selected", "false");
            currentTab.tabIndex = -1;
            currentTabPanel.classList.remove("tab--active");
            currentTabPanel.style.position = null;
            currentTabPanel.style.opacity = null;
            currentTabPanel.style.top = null;
          },
        },
        "p1"
      );
    } else {
      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];
        if (newTab === tab) {
          // new tab
          tab.setAttribute("aria-selected", "true");
          tab.removeAttribute("tabindex");
          this.tabpanels.get(tab).classList.add("tab--active");
          if (setFocus) {
            tab.focus();
          }
        } else {
          tab.setAttribute("aria-selected", "false");
          tab.tabIndex = -1;
          this.tabpanels.get(tab).classList.remove("tab--active");
        }
      }
    }

    this.currentTab = newTab;
    this.dispatchEvent(
      new CustomEvent("tab-component:tab-selected", {
        bubbles: true,
        detail: { tab: newTab, panel: this.tabpanels.get(newTab) },
      })
    );
  }

  setSelectedToPreviousTab(currentTab) {
    var index;
    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    var index;
    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }
  /* EVENT HANDLERS */
  onKeydown(event) {
    const target = event.currentTarget;
    let flag = false;
    switch (event.key) {
      case "ArrowLeft":
        this.setSelectedToPreviousTab(target);
        flag = true;
        break;
      case "ArrowRight":
        this.setSelectedToNextTab(target);
        flag = true;
        break;
      case "Home":
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;
      case "End":
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;
      default:
        break;
    }
    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

if (!customElements.get("tab-component")) {
  customElements.define("tab-component", TabComponent);
}
